import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Global error handler to suppress MetaMask connection errors
window.addEventListener('error', (event) => {
  if (event.error && event.error.message && event.error.message.includes('MetaMask')) {
    console.warn('MetaMask connection error suppressed:', event.error.message);
    event.preventDefault();
    return false;
  }
});

// Handle unhandled promise rejections (like MetaMask connection failures)
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && typeof event.reason === 'string' && event.reason.includes('MetaMask')) {
    console.warn('MetaMask promise rejection suppressed:', event.reason);
    event.preventDefault();
    return false;
  }
  
  if (event.reason && event.reason.message && event.reason.message.includes('MetaMask')) {
    console.warn('MetaMask promise rejection suppressed:', event.reason.message);
    event.preventDefault();
    return false;
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 